import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// attach auth token if present
api.interceptors.request.use((config) => {
    const token =
        localStorage.getItem('mb_admin_token') ||
        localStorage.getItem('mb_student_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Normalize error detail so React never tries to render a raw object
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const d = err?.response?.data?.detail;
        if (d != null && typeof d !== 'string') {
            if (Array.isArray(d)) {
                err.response.data.detail = d
                    .map((it) => (typeof it === 'string' ? it : it?.msg || JSON.stringify(it)))
                    .join('; ');
            } else if (typeof d === 'object') {
                err.response.data.detail = d.msg || JSON.stringify(d);
            } else {
                err.response.data.detail = String(d);
            }
        }
        return Promise.reject(err);
    },
);
